import React, { useEffect } from 'react';
import './Legacy.scss';
import { safeHtml } from '../../services/helpers';

export default function Legacy({
    content,
    onClose
}) {
    useEffect(() => {
        // Désactiver le scroll du body quand le composant est monté
        document.body.style.overflow = 'hidden';

        // Réactiver le scroll quand le composant est démonté
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className='legacy' onClick={handleOverlayClick}>
            <div className='legacy__content'>
                <header className='legacy__header'>
                    <h1>Mentions légales</h1>
                </header>

                <div className='legacy__body'>
                    <div className="policy" dangerouslySetInnerHTML={safeHtml(content)} />

                    {/* Section reCAPTCHA spécifique */}
                    <section className="recaptcha-policy">
                        <h2>Protection reCAPTCHA</h2>
                        <p>
                            Ce site est protégé par reCAPTCHA et les{' '}
                            <a 
                                href="https://policies.google.com/privacy" 
                                target="_blank" 
                                rel="noopener noreferrer"
                            >
                                Règles de confidentialité
                            </a>{' '}
                            et{' '}
                            <a 
                                href="https://policies.google.com/terms" 
                                target="_blank" 
                                rel="noopener noreferrer"
                            >
                                Conditions d'utilisation
                            </a>{' '}
                            de Google s'appliquent.
                        </p>
                    </section>
                    
                </div>
                <footer className='legacy__footer'>
                    <button
                        className='legacy__close-btn'
                        onClick={onClose}
                        aria-label="Fermer les mentions légales"
                    >
                        Fermer
                    </button>
                </footer>
            </div>
        </div>
    );
}
